
import Vue from "vue";
import AppContainer from "@/components/login/LoginContainer.vue";
import AppTitle from "@/components/login/LoginTitle.vue";
import AppText from "@/components/login/LoginText.vue";
import AppSection from "@/components/login/LoginSection.vue";

export default Vue.extend({
	mounted(){
		let splashEl = document.getElementById("splash");
		if (!splashEl) return;
		splashEl.remove();
	},
	components: {
		AppContainer,
		AppTitle,
		AppText,
		AppSection
	},
	i18nEx: {
		componentPrefix: "components.Problem"
	}
});
